import { render, staticRenderFns } from "./eod_details.vue?vue&type=template&id=21ab22ec&scoped=true&"
import script from "./eod_details.vue?vue&type=script&lang=js&"
export * from "./eod_details.vue?vue&type=script&lang=js&"
import style0 from "./eod_details.vue?vue&type=style&index=0&id=21ab22ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab22ec",
  null
  
)

export default component.exports